import { SVGInstance } from "../../../browser/instance/SVGInstance.js";
export class PreserveAspectRatio extends SVGInstance {
    preserveAspectRatio(align, meetOrSlice) {
        if (typeof align === "undefined" && typeof meetOrSlice === "undefined") {
            const preserveAspectRatio = this.attr("preserveAspectRatio");
            if (typeof preserveAspectRatio === "string") {
                const [align, meetOrSlice] = preserveAspectRatio.split(" ");
                return { align, meetOrSlice };
            }
        }
        else if (typeof align === "string" && typeof meetOrSlice === "string") {
            this.attr("preserveAspectRatio", `${align} ${meetOrSlice}`);
            return this;
        }
        else if (typeof align === "string" && typeof meetOrSlice === "undefined") {
            this.attr("preserveAspectRatio", align);
            return this;
        }
        return null;
    }
}
//# sourceMappingURL=preserveAspectRatio.js.map